export default "__VITE_ASSET__DmmOVC6n__"